const updateCurrentMembershipDetails = (state, { payload: { currentMembershipDetails } }) => {
	state.currentMembershipDetails = currentMembershipDetails;
};

export default updateCurrentMembershipDetails;

